<template>
  <div
    id="$address-book$"
    class="width-full height-full bg-F6F6F6 bt address-book"
  >
    <!-- 查看详情 -->
    <div v-if="showSelectDetail" class="width-full height-full fb fb-col">
      <div
        class="item-flex-1 scroll pt-12 pb-60"
        refs="scroller"
        @scroll="handlerToGetNext"
      >
        <div
          v-for="(item, index) in selectedMembers"
          :key="`${item.classDingId}-${item.memberId}`"
          class="bg-FFFFFF pl-16"
          :class="{
            'mt-12':
              index > 0 &&
              item.classDingName !== selectedMembers[index - 1].classDingName,
            'mb-12': index === selectedMembers.length - 1
          }"
        >
          <div
            class="width-full c-191F25-56 lh-20 font-24"
            v-show="
              index > 0
                ? item.classDingName !==
                  selectedMembers[index - 1].classDingName
                : true
            "
            >{{ item.classDingName }}</div
          >
          <div class="bg-FFFFFF h-68 fb fb-main-start fb-cross-center">
            <div class="head-img-text fb fb-main-center fb-cross-center">
              {{ nameLastTwoWords(item.memberName) }}
            </div>
            <div
              class="item-flex-1 height-full fb fb-main-between fb-cross-center"
              :class="{
                bt:
                  index > 0 &&
                  item.classDingName ===
                    selectedMembers[index - 1].classDingName
              }"
            >
              <div class="item-flex-1">
                <div class="fb fb-col fb-main-center p-9-0">
                  <div class="fb fb-main-start fb-cross-center mb-4">
                    <span class="font-34 pr-5 max-w-180 text-ellipsis">{{
                      filterName(item.memberName, 12)
                    }}</span>
                  </div>
                </div>
              </div>
              <i
                class="iconfont font-40 c-171A1D-40 mr-16"
                @click="clearStudent(item)"
                >&#xe670;</i
              >
            </div>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="confirmDetail"
          >确定</common-button
        >
      </div>
    </div>
    <!-- 通讯录页面 -->
    <div v-else class="width-full height-full fb fb-col">
      <!-- 成员搜索输入框 -->
      <common-search-input-box
        class="p-8-0 p-0-8 bg-FFFFFF"
        placeholder="搜索家长姓名"
        :delay="1000"
        :searchValue="searchKey"
        @search="handlerToSearchMembers"
        @focus="handlerToFocusSearch"
        @blur="isFocus = false"
      ></common-search-input-box>
      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="nodeNav.length > 0 && !searchKey"
        :nodeNav="nodeNav"
        @click="handlerBackToNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-show="computedIsShowSelectAll"
        class="h-56 fb fb-row fb-start-center font-34 bg-FFFFFF p-0-16 mb-8"
      >
        <common-checkbox
          :class="{ 'c-171A1D-28': computedIsDisabledSelectAll }"
          :isChecked="!computedIsDisabledSelectAll && compuedIsSelectedAll"
          @click="handlerToChangeSelections"
          ><span class="ml-12">全选</span></common-checkbox
        >
      </div>
      <div class="item-flex-1 scroll">
        <!-- 搜索结果成员列表 -->
        <div v-show="searchKey" class="node-list h-full font-34">
          <div
            v-show="searchMembers.length === 0"
            class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
          >
            <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
            <span class="font-26">没有符合搜索条件的记录</span>
          </div>
          <div
            class="fb fb-row fb-cross-center pl-16 bg-FFFFFF"
            @click="handlerChangeSelected(member)"
            v-for="(member, index) in searchMembers"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="
                  handlerIsSelected(member.selectStatus)
                    ? 'c-006AFE'
                    : 'c-171A1D-24'
                "
                >{{
                  handlerIsSelected(member.selectStatus)
                    ? '&#xe66e;'
                    : '&#xe66f;'
                }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-24">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.studentName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ filterName(member.studentName, 12) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 子级部门列表、部门成员列表 -->
        <div
          v-show="
            !searchKey &&
            ((currentDepts && currentDepts.length) > 0 ||
              (currentMembers && currentMembers.length > 0))
          "
          class="node-list bg-FFFFFF font-34"
        >
          <!-- 子级部门列表 -->
          <div
            v-for="node in currentDepts"
            class="fb-start-center h-56 pl-16 hidden-x"
            :key="node.deptId"
          >
            <span
              class="mr-16"
              :class="[
                'iconfont font-48',
                !node.studentCnt
                  ? 'c-171A1D-12'
                  : node.studentCnt === node.selStudentCnt
                  ? 'c-006AFE'
                  : 'c-171A1D-40'
              ]"
              @click="handlerChangeClassSelected(node, !node.studentCnt)"
            >
              {{
                node.studentCnt && node.studentCnt === node.selStudentCnt
                  ? '&#xe66e;'
                  : '&#xe66f;'
              }}
            </span>
            <div
              class="bb h-full item-flex-1 fb fb-cross-center fb-main-between pr-16 hidden-x"
            >
              <div
                class="item-flex-1 fb fb-cross-center hidden-x"
                @click="handlerChangeClassSelected(node, !node.studentCnt)"
                ><span
                  :class="[
                    'text-ellipsis inline-block w-adapt-60',
                    !node.studentCnt ? 'c-171A1D-28' : 'c-171A1D'
                  ]"
                  >{{ node.deptName }}</span
                ><span
                  :class="[
                    'ml-8',
                    node.studentCnt
                      ? node.selStudentCnt
                        ? 'c-006AFE'
                        : 'c-171A1D-40'
                      : 'c-171A1D-28'
                  ]"
                  v-show="node.studentCnt === node.selStudentCnt"
                  >({{ node.studentCnt }})</span
                >
                <span
                  v-show="node.studentCnt !== node.selStudentCnt"
                  :class="[
                    'ml-8',
                    node.studentCnt
                      ? node.selStudentCnt
                        ? 'c-006AFE'
                        : 'c-171A1D-40'
                      : 'c-171A1D-28'
                  ]"
                  >({{ node.selStudentCnt }}/{{ node.studentCnt }})</span
                ></div
              >
              <div class="c-006AFE font-34">
                <span
                  class="bl-12 pl-9"
                  v-if="
                    node.hasChildren || (+node.type === 3 && node.studentCnt)
                  "
                  @click.stop="handlerToGetSubNodes(node)"
                >
                  <i class="iconfont">&#xe714;</i>下级
                </span>
              </div>
            </div>
          </div>
          <!-- 部门成员列表 -->
          <div
            class="fb fb-row fb-cross-center pl-16"
            @click="handlerChangeSelections(member)"
            v-for="(member, index) in currentMembers"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="
                  handlerIsSelected(member.selectStatus)
                    ? 'c-006AFE'
                    : 'c-171A1D-24'
                "
                >{{
                  handlerIsSelected(member.selectStatus)
                    ? '&#xe66e;'
                    : '&#xe66f;'
                }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-32">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.memberName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ member.memberName }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8"
      >
        <div class="item-flex-1 c-006AFE" @click.stop="handlerViewDetail">
          已选择: {{ memberCount }}人
          <!-- &#xe692; -->
          <i v-show="memberCount" class="ml-8 c-006AFE iconfont font-38"
            >&#xe610;</i
          >
        </div>
        <div>
          <common-button
            type="primary"
            :styles="'font-24'"
            width="95"
            height="32"
            @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import API from '@/api/addressbook'
import {
  commonSearchInputBox,
  commonNodeNav,
  commonHeadImg,
  commonButton,
  commonCheckbox
} from '@/components/commonAddressBook'
import {
  getItem,
  getLocalItem,
  nameLastTwoWords,
  setLeft,
  removeLeft,
  pushNullUrl,
  filterName
} from '@/utils/comUtils'
import {
  mcConfirm,
  mcShowPreloader,
  mcHidePreloader,
  mcToast
} from '@/utils/mcSdkUtils'

export default {
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonHeadImg,
    commonButton,
    commonCheckbox
  },
  props: {},
  data() {
    return {
      filterName,
      nameLastTwoWords,
      nodeNav: [], // 导航栏部门节点对象数组
      currentDepts: [], // 当前展示部门节点列表
      currentMembers: [], // 当前展示成员节点列表
      // 成员搜索相关
      isFocus: false, // 搜索框是否聚焦
      searchKey: '', // 搜索学生姓名关键字
      searchMembers: [], // 当前搜索学生姓名列表
      deptTagList: [], // 选择部门时，标签选择
      showSelectDetail: false, // 展示选择详情
      selectedData: [], // 已选择的数据
      sandboxStatus: 1, // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 已坏掉（处理数据异常） 8 已关闭
      sandboxItvl: null, // 查询状态定时器
      parentId: '', // 父节点id
      classList: [], // 已选班级
      classIndex: 0, // 当前班级
      pageNum: 50, // 分页页码
      classParam: [], // 查人参数
      selectedMembers: [], // 已选学生列表
      clicking: false,
      clearMembersList: [],
      parentDeptType: 0,
      selDeptDingIds: [],
      selStudentDingIds: [],
      isOperateSelect: 0, // 0 未操作 1: 部门 2: 学生
      clearConfirm: null,
      otherConfirm: null
    }
  },
  computed: {
    // 计算是否展示全选
    computedIsShowSelectAll() {
      let _result = true
      // 显示搜索学生姓名 || 无部门无成员 || 选择成员时无可选成员 || 选择部门时无可选部门
      if (
        this.searchKey ||
        (this.currentMembers &&
          this.currentMembers.length === 0 &&
          this.currentDepts &&
          this.currentDepts.length === 0)
      ) {
        _result = false
      }
      return _result
    },
    // 计算禁用全选
    computedIsDisabledSelectAll() {
      let _result = false
      if (this.currentDepts && this.currentDepts.length) {
        let _tag = true
        this.currentDepts.forEach(item => {
          if (item.studentCnt) {
            _tag = false
          }
        })
        _tag && (_result = true)
      }
      return _result
    },
    // 计算全选是否勾选
    compuedIsSelectedAll() {
      let _isSelectAll = true
      if (this.currentDepts && this.currentDepts.length) {
        this.currentDepts.forEach(item => {
          if (item.studentCnt !== item.selStudentCnt) {
            _isSelectAll = false
          }
        })
      } else if (this.currentMembers && this.currentMembers.length) {
        this.currentMembers.forEach(item => {
          if (!this.handlerIsSelected(item.selectStatus)) {
            _isSelectAll = false
          }
        })
      }
      return _isSelectAll
    }
  },
  watch: {},
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    // 钉钉回退按钮监听拦截
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearInterval(this.sandboxItvl)
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    async init() {
      if (!this.sandboxId) {
        await this.addressCreate()
      }
      this.getSandboxStatus()
        .then(res => {
          this.addressGetNodes()
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
      this.methodInitNodeNav()
    },
    // 初始化数据
    initData() {
      this.parentId = '' // 父节点id
      this.parentDeptType = 0
      this.searchKey = ''
      this.searchMembers = []
    },
    // 切换tag
    async handlerTagId(tagid) {
      await this.addressChangeSelections()
      if (this.currentDepts && this.currentDepts.length) {
        this.addressGetNodes()
      } else {
        this.addressQueryClassGuardians()
      }
    },
    // 搜索框聚焦
    async handlerToFocusSearch() {
      this.isFocus = true
      await this.addressChangeSelections()
    },
    // 搜索学生姓名
    async handlerToSearchMembers(searchKey) {
      await this.addressChangeSelections()
      this.searchKey = searchKey
      if (!searchKey) {
        if (this.currentDepts && this.currentDepts.length) {
          this.addressGetNodes()
        }
        if (this.currentMembers && this.currentMembers.length) {
          this.addressQueryClassGuardians()
        }
        return
      }
      this.addressSearchGuaradians()
    },
    // 获取子部门/学生
    async handlerToGetSubNodes(node) {
      if (this.clicking) {
        return
      }
      this.clicking = true
      await this.addressChangeSelections()
      this.methodUpdateNodeNav(node)
      this.parentId = node.deptId
      this.parentDeptType = node.type
      if (+node.type === 3 && node.studentCnt) {
        await this.addressQueryClassGuardians()
        this.clicking = false
      } else {
        await this.addressGetNodes()
        this.clicking = false
      }
    },
    // 判断学生是否勾选
    handlerIsSelected(type) {
      if (+type === 1 || +type === 3) {
        return true
      }
      return false
    },
    // 切换部门勾选状态
    async handlerChangeClassSelected(node, disabled) {
      if (disabled) {
        return
      }
      node.isOperate = true
      this.isOperateSelect = 1
      const _seltag = node.selStudentCnt === node.studentCnt
      node.selStudentCnt = _seltag ? 0 : node.studentCnt
      this.memberCount = await this.addressChangeSelections()
    },
    // 切换学生节点勾选状态 --- 搜索
    async handlerChangeSelected(node) {
      console.log(node)
      const _seltag = this.handlerIsSelected(node.selectStatus)
      let _API = _seltag
        ? 'addressUnselectOneStudent'
        : 'addressSelectOneStudent'
      let _qAPI = this.searchKey
        ? 'addressSearchGuaradians'
        : 'addressQueryClassGuardians'
      await this[_API](node.memberId, node.classDingId)
      this[_qAPI]()
    },
    // 切换学生节点勾选状态
    async handlerChangeSelections(node) {
      this.isOperateSelect = 2
      const _seltag = this.handlerIsSelected(node.selectStatus)
      // 前端直接拿人数加减无法去重 以后端返回的人数为准
      // _seltag ? --this.memberCount : ++this.memberCount
      node.selectStatus = _seltag ? 4 : 3
      this.memberCount = await this.addressChangeSelections()
    },
    // 获取勾选项
    getSelectedIds() {
      if (!this.isOperateSelect) {
        return
      }
      this.selDeptDingIds = []
      this.selStudentDingIds = []
      if (this.currentDepts && this.currentDepts.length) {
        this.selStudentDingIds = null
        this.currentDepts.forEach(item => {
          if (item.isOperate) {
            this.selDeptDingIds.push({
              deptDingId: item.deptId,
              selected: item.studentCnt === item.selStudentCnt
            })
          }
        })
      } else if (this.currentMembers && this.currentMembers.length) {
        this.selDeptDingIds = null
        this.currentMembers.forEach(item => {
          if (this.handlerIsSelected(item.selectStatus)) {
            this.selStudentDingIds.push(item.memberId)
          }
        })
      }
    },
    // 全选操作
    async handlerToChangeSelections() {
      if (this.computedIsDisabledSelectAll) {
        return
      }
      let _isSelected = this.compuedIsSelectedAll
      let _memberCount = this.memberCount
      if (this.currentDepts && this.currentDepts.length) {
        this.isOperateSelect = 1
        this.currentDepts.forEach(item => {
          item.isOperate = true
          const _seltag = item.selStudentCnt === item.studentCnt
          const _unselect = item.studentCnt - item.selStudentCnt
          _isSelected && _seltag && (_memberCount -= item.selStudentCnt)
          !_isSelected && !_seltag && (_memberCount += _unselect)
          item.selStudentCnt = _isSelected ? 0 : item.studentCnt
        })
      } else if (this.currentMembers && this.currentMembers.length) {
        this.isOperateSelect = 2
        this.currentMembers.forEach(item => {
          const _seltag = this.handlerIsSelected(item.selectStatus)
          _isSelected && _seltag && --_memberCount
          !_isSelected && !_seltag && ++_memberCount
          item.selectStatus = _isSelected ? 4 : 3
        })
      }
      _memberCount = await this.addressChangeSelections()

      this.memberCount = _memberCount
    },
    // 查看已选学生
    async handlerViewDetail() {
      if (!this.memberCount) {
        return
      }
      this.clearMembersList = []
      await this.addressChangeSelections()
      this.selectedMembers = []
      await this.addressQuerySelectClasses()
      this.handlerGetClassPage()
      await this.addressQueryClassGuardians(1)
      this.showSelectDetail = true
    },
    // 获取已选学生班级分页
    handlerGetClassPage() {
      let _num = 0
      this.classParam = []
      this.classList &&
        this.classList.length &&
        this.classList.some((item, index) => {
          if (_num >= this.pageNum) {
            return false
          }
          this.classIndex = index + 1
          _num += item.selStudentCnt
          this.classParam.push(item.classDingId)
        })
      this.classList.splice(0, this.classIndex)
    },
    // 加载已选学生下一页搜索结果
    async handlerToGetNext(e) {
      let _el = e.currentTarget
      if (!this.classList.length) return
      if (
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 10 &&
        !this.isLoadDetailMore
      ) {
        this.isLoadDetailMore = true
        this.handlerGetClassPage()
        await this.addressQueryClassGuardians(1)
      }
    },
    // 删除已选学生
    clearStudent(item) {
      this.clearMembersList.push(item.memberId)
      this.selectedMembers.forEach((itm, index) => {
        if (itm.memberId === item.memberId) {
          this.selectedMembers.splice(index, 1)
        }
      })
    },
    // 查看已选 确认
    async confirmDetail() {
      if (this.clearMembersList.length) {
        await this.addressUnslectStudents(this.clearMembersList)
        this.getSandboxStatus()
          .then(res => {
            if (this.currentDepts && this.currentDepts.length) {
              this.addressGetNodes()
            }
            if (this.currentMembers && this.currentMembers.length) {
              this.addressQueryClassGuardians()
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        // this.addressGetNodes()
      }
      this.showSelectDetail = false
    },
    // 查看已选 清空
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选家长`,
        async onConfirm() {
          await that.addressUnslectAll()
          that.showSelectDetail = false
          that.initData()
          that.init()
        }
      }).show()
    },
    // 初始化导航栏
    methodInitNodeNav({ name, deptId = '' } = {}) {
      let _name =
        (getLocalItem(`CURRENT_CAPMUS_${getItem('TOKEN').orgId}`) || {}).name ||
        '通讯录'
      let _node = {
        deptName: name || _name,
        deptId: deptId,
        type: 0
      }
      this.nodeNav = [_node]
    },
    // 更新导航栏
    methodUpdateNodeNav(node, isAdd = true) {
      if (isAdd) {
        this.nodeNav.push(node)
      } else {
        let _index = this.nodeNav.findIndex(item => item.deptId === node.deptId)
        this.nodeNav = this.nodeNav.slice(0, _index + 1)
      }
    },
    // 返回导航栏
    async handlerBackToNode(node) {
      await this.addressChangeSelections()
      this.methodUpdateNodeNav(node, false)
      this.parentId = node.deptId
      this.parentDeptType = node.type
      this.addressGetNodes()
    },
    // 点击确认 关闭选人组件
    async handlerToSubmit() {
      if (this.clicking) {
        return
      }
      await this.addressChangeSelections()
      this.clicking = true
      // 没有冲突人员
      await this.addressCommitPreSelections()
      let _result = {
        memberCount: this.memberCount,
        guardians: this.selectedMembers
      }
      this.close(_result)
    },
    // 回退拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(async btnIndex => {
            if (btnIndex === 1) {
              mcHidePreloader()
              await this.addressRollbackPreSelections()
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 创建选人组件沙盒API
    addressCreate() {
      return new Promise((resolve, reject) => {
        API.createUserSandBox({
          campusId: (this.$store.getters.currentCapmus || {}).tpId || '', // 校区ID
          operUserRoleType: this.$store.getters.currentRole, // 当前角色
          sandboxType: this.sandboxType
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            if (res) {
              thiis.sandboxId = res
              this.$store.commit('sandboxId', res)
              resolve()
            }
          })
          .catch(err => {
            reject(err)
            console.log(err)
          })
      })
    },
    // 轮训查状态API
    getSandboxStatus() {
      // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 提交失败，待重试 8 已坏掉
      this.sandboxStatus = 1
      let _itvlTimes = 0
      mcShowPreloader()
      clearInterval(this.sandboxItvl)
      return new Promise((resolve, reject) => {
        if (this.isSandboxComplete) {
          resolve(true)
        } else {
          this.sandboxItvl = setInterval(async () => {
            ++_itvlTimes
            if (_itvlTimes >= 20) {
              clearInterval(this.sandboxItvl)
              this.addressResetStatus()
              mcHidePreloader()
              mcToast({ msg: '操作超时，请重试～' })
            }
            switch (this.sandboxStatus) {
              case 2:
                this.isSandboxComplete = true
                clearInterval(this.sandboxItvl)
                resolve(this.sandboxStatus)
                break
              case 8:
                clearInterval(this.sandboxItvl)
                this.addressResetStatus()
                mcHidePreloader()
                mcToast({ msg: '操作超时，请重试～' })
                // await this.addressCreate()
                this.initData()
                this.init()
              default:
                await this.addressGetStatus()
                break
            }
          }, 1000)
        }
      })
    },
    // 查询树准备情况API
    addressGetStatus() {
      return new Promise((resolve, reject) => {
        API.addressGetStatus({
          calcStudentSelCnt: true,
          sandboxId: this.sandboxId
        })
          .then(res => {
            this.sandboxStatus = res.sandboxStatus || 0
            this.memberCount = res.selStudentCnt || 0
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查树节点信息API
    addressGetNodes() {
      return new Promise((resolve, reject) => {
        API.addressGetNodes({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          parentDeptId: this.parentId
        })
          .then(res => {
            // type 校区: 0 学段: 1 年级: 2 班级: 3 部门: 4
            this.currentMembers = []
            this.currentDepts = res || []
            mcHidePreloader()
            resolve(res)
          })
          .catch(err => {
            mcHidePreloader()
            console.log(err)
          })
      })
    },
    // 加部门筛选条件（异步）API
    addressSelectDepts(deptIds) {
      return new Promise((resolve, reject) => {
        API.addressSelectDepts({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          deptDingIds: deptIds
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 移除部门筛选条件（异步）API
    addressUnselectDepts(deptIds) {
      return new Promise((resolve, reject) => {
        API.addressUnselectDepts({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          deptDingIds: deptIds
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 加已选学生（异步）API
    addressSelectStudents(studentDingIds) {
      return new Promise((resolve, reject) => {
        API.addressSelectStudents({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          studentDingIds: studentDingIds
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 勾选 API
    addressChangeSelections() {
      this.getSelectedIds()
      if (this.isOperateSelect === 1) {
        return new Promise((resolve, reject) => {
          API.addressChangeDeptSelections({
            campusId: this.campusId,
            sandboxId: this.sandboxId,
            deptSelectionChanges: this.selDeptDingIds
          })
            .then(res => {
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              if (res === 0 || res) {
                this.isOperateSelect = 0
                this.memberCount = res
              }
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        })
      } else if (this.isOperateSelect === 2) {
        return new Promise((resolve, reject) => {
          API.addressChangeClassStudentSelections({
            campusId: this.campusId,
            sandboxId: this.sandboxId,
            classDingId: this.parentId,
            selStudentDingIds: this.selStudentDingIds
          })
            .then(res => {
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              if (res === 0 || res) {
                this.isOperateSelect = 0
                this.memberCount = res
              }
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        })
      }
    },
    // 选中单个学生 API
    addressSelectOneStudent(studentDingId, classDingId) {
      return new Promise((resolve, reject) => {
        API.addressSelectOneStudent({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          studentDingId,
          classDingId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 取消选中单个学生 API
    addressUnselectOneStudent(studentDingId, classDingId) {
      return new Promise((resolve, reject) => {
        API.addressUnselectOneStudent({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          studentDingId,
          classDingId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 移除已选学生（异步）API
    addressUnslectStudents(studentDingIds) {
      return new Promise((resolve, reject) => {
        API.addressUnslectStudents({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          studentDingIds: studentDingIds
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 清除所有已选择API
    addressUnslectAll() {
      return new Promise((resolve, reject) => {
        API.addressUnslectAll({
          campusId: this.campusId,
          sandboxId: this.sandboxId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询已选学生列表-有选项的班级列表API
    addressQuerySelectClasses() {
      return new Promise((resolve, reject) => {
        API.addressQuerySelectClasses({
          campusId: this.campusId,
          sandboxId: this.sandboxId
        })
          .then(res => {
            let _res = res || []
            this.selectedMembers = []
            this.classList = _res
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询已选学生列表-学生列表API
    addressQueryClassGuardians(isSelected) {
      return new Promise((resolve, reject) => {
        API.addressQueryClassStudents({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          classDingIds: isSelected ? this.classParam : [this.parentId],
          selectStatus: isSelected ? [1, 3] : null,
          distinct: true
        })
          .then(res => {
            let _res = (res || []).map(item => ({
              ...item,
              memberId: item.studentDingId,
              memberName: item.studentName
            }))
            if (isSelected) {
              this.selectedMembers = this.selectedMembers.concat(_res) || []
            } else {
              this.currentDepts = []
              this.currentMembers = _res
            }

            mcHidePreloader()
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
          .finally(() => {
            this.isLoadDetailMore = false
          })
      })
    },
    // 搜索学生API
    addressSearchGuaradians() {
      return new Promise((resolve, reject) => {
        API.addressSearchStudents({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          limit: 20,
          q: this.searchKey,
          distinct: true
        })
          .then(res => {
            let _res = (res || []).map(item => ({
              ...item,
              memberId: item.studentDingId,
              memberName: item.studentName
            }))
            this.searchMembers = _res
            mcHidePreloader()
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
      })
    },
    // 提交预选项API
    addressCommitPreSelections() {
      return new Promise((resolve, reject) => {
        API.addressCommitPreSelections({
          campusId: this.campusId,
          sandboxId: this.sandboxId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 取消预选项
    addressRollbackPreSelections() {
      return new Promise((resolve, reject) => {
        API.addressRollbackPreSelections({
          campusId: this.campusId,
          sandboxId: this.sandboxId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询沙盒变更概述
    addressGetChangeSummary() {
      return new Promise((resolve, reject) => {
        API.addressGetChangeSummary({
          campusId: this.campusId,
          sandboxId: this.sandboxId,
          returnConflictStudentNamesLimit: 1
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 重置沙箱
    addressResetStatus() {
      return new Promise((resolve, reject) => {
        API.addressResetStatus({
          campusId: this.campusId,
          sandboxId: this.sandboxId
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 22;
  overflow-y: scroll;
}

.node-list {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 2px;
}
.head-img-text {
  height: 36px;
  width: 36px;
  color: #ffffff;
  margin-right: 12px;
  background: #006afe;
  border-radius: 50%;
}
.footer {
  :deep(.c-button) {
    height: 46px;
    line-height: 46px;
    border-radius: 8px;
  }
}
</style>
